var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"relative overflow-hidden"},[_c('app-header'),_c('router-view'),_c('app-footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }